import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from "./AiModel.module.scss";
import { title } from "process";
import Image from "next/image";

function AiModel() {
  const categoryItems = [
    {
      icon: "/retail-data.png",
      title: "Retail Data",
      description:
        "We provide tailored retail data solutions, offering insights on customer behavior, pricing, and inventory optimization to boost efficiency and competitiveness.",
    },
    {
      icon: "/price-comparison.png",
      title: "Price Comparison Data",
      description:
        "We offer real-time price comparison data, empowering businesses to optimize pricing strategies, track trends, and boost competitiveness and profitability.",
    },
    {
      icon: "/consumer-trend.png",
      title: "Consumer Trends Data ",
      description:
        "We deliver real-time consumer trends data, offering insights into evolving behaviors and preferences to help businesses stay competitive and drive growth.",
    },
    {
      icon: "/social-data.png",
      title: "Social Data",
      description:
        "We provide social data insights, helping businesses optimize marketing, track brand reputation, and enhance customer engagement through data-driven strategies.",
    },
    {
      icon: "/market-trend.png",
      title: "Market Capture Data",
      description:
        "Our Market Capture Data service provides actionable insights on market trends, competitor performance, and consumer behavior, helping businesses optimize strategies and drive growth.",
    },
    {
      icon: "/Geospatial-data.png",
      title: "Geospatial Data",
      description:
        "We offer geospatial data insights, helping businesses leverage location-based information for smarter decisions, competitive advantage, and sustainable growth.",
    },
  ];

  return (
    <div className={styles["ai-model"]}>
      <div className={styles["ai-model-header"]}>
        <h2>Diverse data types for comprehensive model training</h2>
      </div>
      <div className={styles["ai-model-content"]}>
        <div className={styles["feature-list"]}>
          {categoryItems?.map((item: any, index: any) => (
            <div
              className={styles["feature-card"]}
              key={`feature-card-${index}`}
            >
              <div className={styles["feature-icon"]}>
                <Image
                  height={48}
                  width={48}
                  alt={`feature-icon-${index}`}
                  src={item.icon}
                />
              </div>
              <div className={styles["feature-card-title"]}>{item?.title}</div>
              <div className={styles["feature-card-sub-title"]}>
                {item?.description}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default AiModel;
